import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div>
      <h1>Oops... can't find this page!</h1>
      <h2>
        <Link to={'/'}>Back to the Home page</Link>
      </h2>
    </div>
  );
};

export default NotFound;
